import { useQuery } from '@tanstack/react-query';
import { getApps } from 'api/appManager';
import { LIST_APP_QUERY } from 'constants/QueryString';

const useAppsQuery = (query) => {
  const { data, isLoading, refetch, error } = useQuery({
    queryKey: [LIST_APP_QUERY, query],
    queryFn: async () => {
      try {
        return await getApps(query);
      } catch (error) {
        throw error;
      }
    },
  });

  return {
    data,
    isLoading,
    refetch,
    error,
  };
};

export default useAppsQuery;